export const SidebarData1 = {
  crm: [
    {
      tittle: "Dashboard",
      hasSubRoute: false,
      icon: "layout-grid",
      showSubRoute: false,
      route: "/crm/dashboard",
    },
    {
      tittle: "Sales",
      hasSubRoute: true,
      icon: "trending-up",
      showSubRoute: true,
      subRoutes: [
        {
          tittle: "Leads",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/leads",
        },
        {
          tittle: "Proposal",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/proposals",
        },
        {
          tittle: "Reports",
          hasSubRoute: true,
          icon: "chart-line",
          showSubRoute: true,
          subRoutes: [
            {
              tittle: "Invoices Due",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/crm/reports/reportId=5",
            },
            {
              tittle: "Expired Estimates",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/crm/reports/reportId=6",
            },
            {
              tittle: "Expired Proposals",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/crm/reports/reportId=7",
            },
            // {
            //   tittle: "Payments",
            //   hasSubRoute: false,
            //   showSubRoute: false,
            //   route: "/crm/reports/reportId=8",
            // },
          ],
        },
        {
          tittle: "Campaign",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/campaign",
        },
      ],
    },
    {
      tittle: "Customers",
      hasSubRoute: false,
      icon: "users",
      showSubRoute: false,
      route: "/crm/customers",
    },

    {
      tittle: "Projects",
      hasSubRoute: false,
      icon: "briefcase",
      showSubRoute: false,
      route: "/crm/projects",
    },
    {
      tittle: "Tasks",
      hasSubRoute: false,
      icon: "list-check",
      showSubRoute: false,
      route: "/crm/tasks",
    },

    {
      tittle: "Billing",
      hasSubRoute: true,
      icon: "file-text",
      showSubRoute: true,
      subRoutes: [
        {
          tittle: "Estimates",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/estimates",
        },
        {
          tittle: "Invoices",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/invoices",
          subRoutes: [],
        },
      ],
    },
    {
      tittle: "Finance",
      hasSubRoute: true,
      icon: "wallet",
      showSubRoute: true,
      subRoutes: [
        {
          tittle: "Payments",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/payments",
        },
        {
          tittle: "Expenses",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/expenses",
        },
        {
          tittle: "Credit Notes",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/creditnotes",
        },
      ],
    },

    {
      tittle: "Reports",
      hasSubRoute: true,
      icon: "chart-line",
      showSubRoute: true,

      subRoutes: [
        // {
        //   tittle: "Sales",
        //   hasSubRoute: true,
        //   icon: "shopping-cart",
        //   showSubRoute: true,

        //   subRoutes: [
        //     {
        //       tittle: "Invoices Due",
        //       hasSubRoute: false,
        //       showSubRoute: false,
        //       route: "/crm/reports/invoices-due",
        //     },
        //     {
        //       tittle: "Expired Estimates",
        //       hasSubRoute: false,
        //       showSubRoute: false,
        //       route: "/crm/reports/expired-estimates",
        //     },
        //     {
        //       tittle: "Expired Proposals",
        //       hasSubRoute: false,
        //       showSubRoute: false,
        //       route: "/crm/reports/expired-proposals",
        //     },
        //     {
        //       tittle: "Payments",
        //       hasSubRoute: false,
        //       showSubRoute: false,
        //       route: "/crm/reports/payments",
        //     },
        //   ],
        // },
        {
          tittle: "New Leads",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/reports/reportId=2",
        },
        {
          tittle: "Customer Conversion",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/reports/reportId=1",
        },
        // Reminders
        {
          tittle: "Reminders",
          hasSubRoute: false,
          icon: "bell",
          showSubRoute: false,
          route: "/crm/reports/reportId=3",
        },

        // Notes
        {
          tittle: "Notes",
          hasSubRoute: false,
          icon: "file-text",
          showSubRoute: false,
          route: "/crm/reports/reportId=4",
        },
      ],
    },
    {
      tittle: "Config",
      hasSubRoute: true,
      icon: "settings",
      showSubRoute: true,
      subRoutes: [
        {
          tittle: "Product",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/products",
        },
        {
          tittle: "Notifications",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/Notifications",
        },
        {
          tittle: "Messages",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/Messages",
        },
        {
          tittle: "SqlQueries",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/crm/queries",
        },
      ],
    },
  ],
};
